import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { resetUserPassword } from "actions/auth";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
//import CardHeader from '@mui/material/CardHeader';
//import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
//import { CardActionArea } from '@mui/material';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Alert from '@mui/material/Alert';
import typography from "assets/mavric-theme/base/typography";
import colors from "assets/mavric-theme/base/colors";
import Box from '@mui/material/Box';
import ResetBgImg from "assets/img/reset_password.png";
import { resetMonitorUserPassword, resetPortalUserPassword } from "apis/CustomersApis";
import { digestMessage, getKeyValue } from 'common_utils/utils';


const { size } = typography;
const { primary, secondary, text } = colors;


export default function MonitorUserResetPassword({ bizUsrInfo, selectedCustomer, UserReset, handleCloseForm, inProcess, isPortalUser, ...props }) {

  //Uses history to redirect page.
  let history = useHistory();

  //Get the Redux state values
  const dispatch = useDispatch();
  const StateMsgError = useSelector(state => state.error);
  const isStateError = useSelector(state => state.isError);
  const isStateSuccess = useSelector(state => state.isSuccess);
  const StateMsgSuccess = useSelector(state => state.successMsg);

  //Error Handling for page
  const [PageHandleMsgError, setPageAlertMsg] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [pageAlertType, setPageAlertType] = useState("error"); //error, warning, info, success

  //Password Fields
  const [newPassword, setNewPassword] = useState(""); //New Password 
  const [confPassword, setConfPassword] = useState("");//Confirm Password

  //Properties from previous form.
  const initialUserInfo = { Company: "Wohler", user_id: 0, customer_id: 0, email: null, phone: null, first_name: null, last_name: null, role: 'Operator', role_id: 3 };
  const [userInfo, setUserInfo] = useState((undefined === bizUsrInfo || bizUsrInfo === null) ? initialUserInfo : bizUsrInfo);
  const [usrEmail, setEmailAddr] = useState(userInfo.email || '');
  const [isProc, setIsProc] = useState(inProcess || false);
  const [customerId, setCustomerId] = useState(selectedCustomer && selectedCustomer.customer_id || '');
  const [userId, setUserId] = useState(userInfo.user_id || '');
  const [enableCloseBtn, setEnableCloseBtn] = useState(false);



  useEffect(() => {
  }, [enableCloseBtn]);

  useEffect(() => {
    if (isProc) {
      if (isStateSuccess) {
        setSuccessAlert(StateMsgSuccess);
      }
      if (isStateError) {
        if (StateMsgError.includes("Invalid password provided") || StateMsgError.includes("500")) {
          setErrorAlert("Invalid password provided");
        } else {
          setErrorAlert(StateMsgError);
        }
      }
    } else {
      setShowAlert(false);
      setIsProc(true);
    }

  }, [isStateError, StateMsgError, isStateSuccess, StateMsgSuccess]);


  const setErrorAlert = (msg) => {
    setPageAlertType("error");
    setShowAlert(true);
    setPageAlertMsg(msg);
  }

  const setSuccessAlert = (msg) => {
    setPageAlertType("success");
    setShowAlert(true);
    setPageAlertMsg(msg);
  }

  const hideAlert = () => {
    setPageAlertMsg("");
    setShowAlert(false);
    setEnableCloseBtn(false);
  }

  const handleReserUserPassword = (userInfo) => {
    resetMonitorUserPassword(userInfo)
      .then((result) => {

        let responseCode = getKeyValue(result, "code", 0);
        console.log("result : ", result);
        if (responseCode == 200) {
          setPageAlertType("success");
          setShowAlert(true);
          setPageAlertMsg("Successfully updated password");
        } else {
          setShowAlert(true);
          setPageAlertMsg("An Error has ocurred");
        }


      }).catch((error) => {
        if (error.response) {
          console.log("error.response :", error.response);
          setErrorAlert(JSON.stringify(error.response.data));
        }
      });
    setEnableCloseBtn(true);
  };


  const handleResetPortalUserPassword = (userInfo) => {
    const { ...portalUserInfo } = userInfo;

    resetPortalUserPassword(portalUserInfo)
      .then((result) => {
        let responseCode = getKeyValue(result, "code", 0);
        console.log("result : ", result);
        if (responseCode === 200) {
          setPageAlertType("success");
          setShowAlert(true);
          setPageAlertMsg("Successfully updated password");
        } else {
          setShowAlert(true);
          setPageAlertMsg("An error has occurred");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log("error.response :", error.response);
          setErrorAlert(JSON.stringify(error.response.data));
        } else {
          setErrorAlert("Network error occurred");
        }
      });
    setEnableCloseBtn(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (newPassword === "" || confPassword === "") {
      setErrorAlert("Fields are required");
      return;
    }

    if (newPassword !== confPassword) {
      setErrorAlert("Passwords do not match.");
      return;
    }

    digestMessage(newPassword).then(newHashPswd => {
      const baseUserInfo = {
        new_password: newHashPswd,
        user_id: userId
      };
      if (isPortalUser) {
        handleResetPortalUserPassword(baseUserInfo);
      } else {
        handleReserUserPassword({
          ...baseUserInfo,
          customer_id: customerId
        });
      }
    });
  };


  return (
    <>
      <Grid container direction="column" spacing={0} justifyContent="flex-start" alignItems="center" >
        <Grid item>
          <Card>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <Grid container direction="column" spacing={2} justifyContent="center" alignItems="center" >
                  <Grid item>
                    <Box
                      component="img"
                      alt="Wohler Logo"
                      src={ResetBgImg}
                      justifyContent="center"
                    />
                  </Grid>
                  <Grid item>
                    <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600, }}>Email Address</Typography>
                    <TextField
                      sx={{ width: 300, color: "#E5E5E5" }}
                      id='usrEmail'
                      name='usrEmail'
                      placeholder="User Email"
                      value={usrEmail}
                      focused={false}
                      variant="outlined"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600, }}>New Password</Typography>
                    <TextField
                      sx={{ width: 300 }}
                      id="filled-password-input"
                      type="password"
                      autoComplete="current-password"
                      variant="outlined"
                      inputProps={{
                        onChange: (e) => {
                          hideAlert();
                          setNewPassword(e.target.value);
                        }
                      }}
                      placeholder="New Password"
                    />
                  </Grid>
                  <Grid item>
                    <Typography fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 600, }}>Confirm Password</Typography>
                    <TextField
                      sx={{ width: 300 }}
                      id="filled-password-input"
                      type="password"
                      autoComplete="current-password"
                      variant="outlined"
                      inputProps={{
                        onChange: (e) => {
                          hideAlert();
                          setConfPassword(e.target.value);
                        }
                      }}
                      placeholder="Confirm Password"
                    />
                  </Grid>
                  <Grid item>

                    {(enableCloseBtn)
                      ? <Button type="submit" variant="contained" color="secondary" name="closeBtn" onClick={handleCloseForm} > Close </Button>
                      : <Button type="submit" onClick={handleSubmit} variant="contained" color="secondary"> Reset Password </Button>
                    }
                  </Grid>

                  <Grid item>
                    {(showAlert) && (
                      <Alert variant="filled" severity={pageAlertType} onClick={() => setShowAlert(false)} sx={{ py: 0 }}>
                        <Typography fontSize={size.sm} color={text.main} sx={{ fontWeight: 400 }}>{PageHandleMsgError}</Typography>
                      </Alert>
                    )}
                  </Grid>

                </Grid>
              </form>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );

} 